import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import stage from '../components/stage'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class Nav extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    
    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0


    this.ref = {
        location: [],
        nav: null,
        hamburger: null,
        reservations: null,
        order: null,
        mobile: null, 
        mobileloc :null,
        mobilelocations :null

    }

  }

  mount() {

  
    this.modal = document.getElementById('modal')
    this.iframe = document.getElementById('modal__iframe')

     $('[data-button]').on('click', (e) => {
       this.close()
     })
   

     this.ref.nav.addEventListener('mouseenter', (e)=>{
      if(stage.w > 640){
         this.ref.nav.classList.add('is-hover')
      }
       
     })

     this.ref.nav.addEventListener('mouseleave', (e) => {
       this.ref.nav.classList.remove('is-hover')
     })

     this.ref.nav.addEventListener('mouseleave', (e) => {
       this.ref.nav.classList.remove('is-hover')
     })

     $('a', this.ref.mobile).on('click', (e)=>{
        document.body.classList.remove('has-mobile-nav')
        this.ref.mobilelocations.classList.remove('selected')
        this.ref.reservations.parentElement.classList.remove('selected')
        this.ref.order.parentElement.classList.remove('selected')
     })

     
     this.ref.hamburger.addEventListener('click', (e) => {
       document.body.classList.toggle('has-mobile-nav')
       this.ref.reservations.parentElement.classList.remove('selected')
       this.ref.order.parentElement.classList.remove('selected')
     })

     $(this.ref.reservations).on('click', (e) => {
       this.ref.reservations.parentElement.classList.toggle('selected')
       
     })
     $(this.ref.order).on('click', (e) => {
       this.ref.order.parentElement.classList.toggle('selected')
     })

     $(this.ref.mobileloc).on('click', (e) => {
      e.preventDefault()
      this.ref.mobilelocations.classList.toggle('selected')
    })


  _each(this.ref.location, (item) => {


    $(item).on('click', (e) => {
      e.preventDefault()
      
      //const loc = `https://www.sevenrooms.com/reservations/${item.dataset.location}`
      //const loc = `https://www.sevenrooms.com/explore/${item.dataset.location}/reservations/create/search/?venues=kricketsoho,kricketcanarywharf,kricketbrixton,kricketwhitecity`
      const loc = item.dataset.link
      const img = item.dataset.location
      this.show(loc, img)

    })


  })

  $('.anchor').on('click', (e)=>{
     const anchor = e.currentTarget.getAttribute('href')
     lenis.scrollTo(anchor, {lerp: 0.33})
  })

  
      
}

show(loc, img) {

  lenis.stop()
  this.iframe.src = loc
  this.modal.classList.add('is-opened')

 
  $('.currentbg').removeClass('currentbg')

  const bg = document.getElementById(img)
  bg.classList.add('currentbg')


}

close() {
  lenis.start();
  this.modal.classList.remove('is-opened', 'has-overlay')
  this.iframe.src = ""

}






resize(){
  
}

  unmount() {

this.element.querySelectorAll('a[href^="#"]').forEach(anchor => {
  $(anchor).off('click');
})
 $('[data-button]').off('click')

  }


}

module.exports = Nav
